import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const CoverageMetrics = ({ data }) => {
  const [activeTab, setActiveTab] = useState('department');

  const displayData = activeTab === 'department' ? data?.byDepartment : data?.byLocation;

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-green-500/10 flex items-center justify-center">
            <Icon name="Users" size={20} className="text-green-500" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-foreground">Coverage Metrics</h3>
            <p className="text-sm text-muted-foreground">Personnel training status</p>
          </div>
        </div>
      </div>
      {/* Tabs */}
      <div className="flex gap-2 mb-4 p-1 bg-muted rounded-lg">
        <button
          onClick={() => setActiveTab('department')}
          className={`flex-1 px-4 py-2 rounded-md text-sm font-medium transition-colors ${
            activeTab === 'department' ?'bg-card text-foreground shadow-sm' :'text-muted-foreground hover:text-foreground'
          }`}
        >
          By Department
        </button>
        <button
          onClick={() => setActiveTab('location')}
          className={`flex-1 px-4 py-2 rounded-md text-sm font-medium transition-colors ${
            activeTab === 'location' ?'bg-card text-foreground shadow-sm' :'text-muted-foreground hover:text-foreground'
          }`}
        >
          By Location
        </button>
      </div>
      {/* Coverage List */}
      <div className="space-y-3 mb-6">
        {displayData?.map((item, index) => (
          <div key={index} className="p-4 bg-muted/50 rounded-lg">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm font-medium text-foreground">{item?.name}</span>
              <div className="flex items-center gap-2">
                <span className="text-sm font-semibold text-foreground">{item?.rate}%</span>
                {item?.overdue > 0 && (
                  <span className="px-2 py-0.5 bg-destructive/10 text-destructive text-xs font-medium rounded-full">
                    {item?.overdue} overdue
                  </span>
                )}
              </div>
            </div>
            <div className="w-full bg-muted rounded-full h-2 mb-2">
              <div
                className="bg-success h-2 rounded-full transition-all"
                style={{ width: `${item?.rate}%` }}
              />
            </div>
            <div className="flex items-center gap-4 text-xs text-muted-foreground">
              <span>{item?.trained} trained</span>
              <span>•</span>
              <span>{item?.total - item?.trained} pending</span>
              <span>•</span>
              <span>{item?.total} total</span>
            </div>
          </div>
        ))}
      </div>
      {/* New Hires Section */}
      <div className="pt-4 border-t border-border">
        <div className="flex items-center gap-2 mb-3">
          <Icon name="UserPlus" size={16} className="text-primary" />
          <h4 className="text-sm font-semibold text-foreground">New Hire Training Status</h4>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div className="p-3 bg-muted/50 rounded-lg">
            <p className="text-xs text-muted-foreground mb-1">Orientation</p>
            <p className="text-lg font-bold text-foreground">
              {data?.newHires?.orientationComplete}/{data?.newHires?.total}
            </p>
          </div>
          <div className="p-3 bg-muted/50 rounded-lg">
            <p className="text-xs text-muted-foreground mb-1">Basic Training</p>
            <p className="text-lg font-bold text-foreground">
              {data?.newHires?.basicTrainingComplete}/{data?.newHires?.total}
            </p>
          </div>
          <div className="p-3 bg-muted/50 rounded-lg">
            <p className="text-xs text-muted-foreground mb-1">Advanced</p>
            <p className="text-lg font-bold text-foreground">
              {data?.newHires?.advancedTrainingComplete}/{data?.newHires?.total}
            </p>
          </div>
          <div className="p-3 bg-muted/50 rounded-lg">
            <p className="text-xs text-muted-foreground mb-1">Avg Days</p>
            <p className="text-lg font-bold text-foreground">
              {data?.newHires?.avgCompletionTime}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoverageMetrics;